import { convertToUTC } from '@/Data/Functions/dateLocalisation';
import apiUrls from '@/Data/Objects/apiUrls';
import { DateTime } from 'luxon';

const product = {
    state: {
        colours: [],
        cached: null
    },
    getters: {
        getColours(state) {
            return state.colours.filter(colour => colour != '');
        }
    },
    mutations: {
        setColours(state, colours) {
            state.colours = colours;
        },
        setCached(state, cached) {
            state.cached = cached;
        }
    },
    actions: {
        getColourList({ commit, state }) {
            let promiseResult;

            if (state.colours.length > 0 && state.cached !== null && DateTime.fromISO(state.cached, { zone: 'utc' }).plus({ weeks: 1 }) > convertToUTC(DateTime.now())) {
                promiseResult = Promise.resolve();
            }
            else {
                promiseResult = this._vm.$api(apiUrls.views.colours)
                    .then((response) => {
                        commit('setColours', response.data);
                        commit('setCached', convertToUTC(DateTime.now()).toISO());
                    })
                    .catch(() => { /* Errors are handled by the global interceptor */ });
            }

            return promiseResult;
        }
    }
};

export default product;
